export const formatNumber = (value: number | undefined | null): string => {
  if (value === undefined || value === null) {
    return '';
  }
  if (Number.isInteger(value)) {
    if (Math.abs(value) >= 1000) {
      return value.toLocaleString('en-US');
    }
  }
  return String(value);
};